import { render, staticRenderFns } from "./sub-visual-borad.vue?vue&type=template&id=44967bd8&scoped=true&"
import script from "./sub-visual-borad.vue?vue&type=script&lang=js&"
export * from "./sub-visual-borad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44967bd8",
  null
  
)

export default component.exports